export default "__VITE_ASSET__0c0ff9d5__"